import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import imagem1 from "../../images/imagem13.jpg";
import Globais from "../../css/Globais";
import familiaResort from "../../images/familia-resort.jpg";

const SectionWrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  border-top: 1px solid #eee;
  text-align: center;

  @media (min-width: 768px) {
    padding: 6rem 4rem;
  }
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #222;

  @media (min-width: 768px) {
    font-size: 2.4rem;
  }
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const BulletList = styled.ul`
  text-align: left;
  margin: 0 auto 2rem;
  max-width: 600px;
  padding-left: 1rem;

  li {
    font-size: 1rem;
    margin-bottom: 1rem;
    color: #444;
  }
`;

const Quote = styled.blockquote`
  font-size: 1.2rem;
  font-style: italic;
  color: #333;
  margin-bottom: 2.5rem;

  strong {
    font-weight: 700;
    color: #0077cc;
  }
`;
const CTAButton = styled.a`
  display: inline-block; /* importante */
  max-width: 100%; /* evita overflow */
  text-align: center;
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 1.8rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  transition: background 0.3s ease;
  word-break: break-word; /* força quebra de linha em dispositivos pequenos */

  &:hover {
    background-color: #005fa3;
  }
`;



const ViewVender = () => {
  return (
    <SectionWrapper>
      <Content>
        <Title>Quer vender sua cota de multipropriedade com segurança, apoio e mais chances de fechar?</Title>

        <Paragraph>
          A Multicotas é pioneira e a <strong>única plataforma de vendas de multipropriedade na América Latina</strong>. 
          Isso significa que você tem acesso a um sistema exclusivo, confiável e que conecta você com milhares de interessados. Além disso, você pode optar por um processo completo, com auxílio de nossos parceiros, pensado para gerar resultado real com tranquilidade.
        </Paragraph>

           <Paragraph>
          <strong>Por que vender conosco?</strong>
        </Paragraph>

        <BulletList>
          <li>📢 Exclusividade no mercado latino-americano</li>
          <li>💼 Anúncio ativo por 12 meses</li>
          <li>💬 Suporte por WhatsApp e contato direto com interessados</li>
           <li>📋 Possibilidade de acompanhamento jurídico com escritório parceiro no fechamento da venda</li>
            <li>💳 Opção de financiamento com financeira parceira — mais chances de fechar negócio!</li>
          <li>💰 Investimento simbólico: apenas R$ 9,90/mês - sem comissão ou corretagem</li>
        </BulletList>

        <Quote>
          Às vezes, a melhor forma de aproveitar a multipropriedade… é
          <strong> se libertar dela com estratégia.</strong>
        </Quote>

        <CTAButton href="#formulario">
          Quero anunciar minha cota para venda
        </CTAButton>
      </Content>
    </SectionWrapper>
  );
};


export default ViewVender;



